import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { bindPropStore } from "../bindProps";
import { text } from "../helpers";
import InlineIcon from "../InlineIcon.svelte";

var root = $.from_html(`<a class="slex-link"><!> <span> </span></a>`);

export default function Link($$anchor, $$props) {
	$.push($$props, true);

	let p = $.state($.proxy({}));

	$.user_effect(() => bindPropStore($$props.props, (next) => $.set(p, next, true)));

	var a = root();
	var node = $.child(a);

	{
		var consequent = ($$anchor) => {
			InlineIcon($$anchor, {
				get name() {
					return $.get(p).icon;
				},
				className: 'slex-link-icon'
			});
		};

		$.if(node, ($$render) => {
			if ($.get(p).icon) $$render(consequent);
		});
	}

	var span = $.sibling(node, 2);
	var text_1 = $.child(span, true);

	$.reset(span);
	$.reset(a);

	$.template_effect(
		($0, $1, $2, $3) => {
			$.set_attribute(a, 'data-variant', $0);
			$.set_attribute(a, 'href', $1);
			$.set_attribute(a, 'target', $2);
			$.set_attribute(a, 'rel', $.get(p).target === "_blank" ? "noreferrer" : undefined);
			$.set_text(text_1, $3);
		},
		[
			() => text($.get(p).variant),
			() => text($.get(p).href, "#"),
			() => text($.get(p).target) || undefined,
			() => text($.get(p).text ?? $.get(p).label ?? $.get(p).content ?? $.get(p).href)
		]
	);

	$.append($$anchor, a);
	$.pop();
}